import BillingGroup from '../components/templates/[billing-group-id]';

export const BillingGroupContainer = () => {
  return <BillingGroup />;
};
